module.exports = "<div data-component=\"summary\" class=\"step\" *ngIf=\"active\">\n\t<div *ngFor=\"let message of messages\">\n\t\t<app-warning [message]=\"message\" [type]=\"success ? 'success' : 'error'\"></app-warning>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-result/transaction-result.component.html
// module id = ../../../../../src/app/master/transaction-history/transaction-result/transaction-result.component.html
// module chunks = main